export default __webpack_public_path__ + "static/media/thumbnail1.9f2ae598.jpg";